// extracted by mini-css-extract-plugin
module.exports = {"base":"StatusBlock_base__3VqDj","row":"StatusBlock_row__28jVb","bold":"StatusBlock_bold__2jk6E"};